import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class BehaviorSignalEndpointsService {
  readonly #service = inject(ServicesService);

  public getBehaviorSignals(
    actor: string,
    arrangementCode: string,
    contentIdentifier: string,
  ): string {
    return this.#service.think(
      `behavior/signals/${arrangementCode}/${contentIdentifier}?actor=${actor}`,
    );
  }
}
